import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {NotifierService} from '../services/notifier.service';
import { ModalService } from '../services/modal.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private notifierService: NotifierService,
    private modalService: ModalService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.auth()) {
      return true;
    }
    const queryParams: { returnUrl?: string; returnParams?: string; } = {};
    const stateUrl = state.url;
    if (stateUrl.indexOf('?') > -1) {
      const splitStateUrl = stateUrl.split('?');
      queryParams.returnUrl = splitStateUrl[0];
      queryParams.returnParams = splitStateUrl[1];
    } else {
      queryParams.returnUrl = stateUrl;
    }
    this.notifierService.notify('warning', 'You need to be logged in to access this section.');
    this.router.navigate(['/'], {queryParams});
    return false;
  }
}
